import TabletsOverviewPageComponent from "@/views/tablets/tablets.component.vue";
import TabletPageComponent from "@/views/tablet-page.vue";
import HomeComponent from "@/views/home-page.vue";
import LoginComponent from "@/views/login/login.component.vue";
import PlayersPageComponent from "@/views/players/players-page.component.vue";
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import beforeEachRouteEnter from "./before-each";
import PlayerPageComponent from "@/views/player-page.vue";
import PlayerInnerPageComponent from "@/views/player-inner/player-inner-page.component.vue";
import PlayerScreenshotsPageComponent from "@/views/player-screenshots-page.vue";
import TabletScreenshotsPageComponent from "@/views/tablet-screenshots-page.vue";
import PlayerGroupsPageComponent from "@/views/player-groups-page.vue";
import PlayerGroupPageComponent from "@/views/group-page.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: HomeComponent,
  },
  {
    path: "/tablets",
    name: "AndroidList",
    component: TabletsOverviewPageComponent,
  },
  {
    path: "/tablets/:id",
    component:  TabletPageComponent,
    children: [
      {
        path: 'screenshots',
        name: 'TabletScreenshotsPage',
        component: TabletScreenshotsPageComponent,
      }
    ]
  },
  {
    path: "/groups",
    name: "PlayerGroupsPage",
    component: PlayerGroupsPageComponent,
  },
  {
    path: '/groups/:id',
    name: "PlayerGroupInnerPage",
    component: PlayerGroupPageComponent,
  },
  {
    path: "/players",
    name: "PlayersPage",
    component: PlayersPageComponent,
  },
  {
    path: "/players/:id",
    component: PlayerPageComponent,
    children: [
      {
        path: '',
        name: "PlayerInnerPage",
        component: PlayerInnerPageComponent,
      },
      {
        path: "screenshots",
        name: "PlayerScreenshotsPage",
        component: PlayerScreenshotsPageComponent,
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: LoginComponent,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(
  async (to, from, next) => await beforeEachRouteEnter(to, from, next)
);

export default router;
